// removed by extract-text-webpack-plugin
module.exports = {"InputNewOption":"JwfJGfQyFk5aLyzdCPoZm","InnerTextInput":"_1vpkKMRuVePHJyzah8T6ce"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/style.css
// module id = 479
// module chunks = 0